import { render } from "./sidebar-content.vue?vue&type=template&id=b4c0b800&scoped=true"
import script from "./sidebar-content.vue?vue&type=script&lang=js"
export * from "./sidebar-content.vue?vue&type=script&lang=js"

import "./sidebar-content.vue?vue&type=style&index=0&id=b4c0b800&scoped=true&lang=css"
import "./sidebar-content.vue?vue&type=style&index=1&id=b4c0b800&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4c0b800"]])

export default __exports__